import React from "react";
import { MessageCircle } from "lucide-react";
import { siteData } from "../mock";

export default function WhatsappBubble() {
  const { whatsapp } = siteData.brand;
  return (
    <a
      href={`https://wa.me/${whatsapp}?text=${encodeURIComponent("Hi JK Estates, I'd like to enquire about a property.")}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp JK Estates"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1eba58] text-white flex items-center justify-center shadow-[0_6px_20px_rgba(37,211,102,0.45)] transition-colors"
    >
      <MessageCircle className="w-6 h-6" fill="currentColor" stroke="#25D366" strokeWidth={0} />
    </a>
  );
}
